import { MultiRemovePasswordFromGroupEntry } from "./MultiRemovePasswordFromGroupEntry";

export class MultiRemovePasswordFromGroupRequest {
    entries: MultiRemovePasswordFromGroupEntry[] = [];
}